import { Stringifiable } from "zeta-dom-react";
import { linkTo, matchView, ViewComponent } from "brew-js-react";
import { translate as t } from "src/i18n";
import * as views from "src/views";
import { app } from "./app";
import { IconNames } from "src/components/common";

interface NavigationItem {
    label: string;
    href: string;
}

type V = ViewComponent<any>;

const firstLevelViews: V[] = [...Object.values(views) as V[]];

const titles: Map<V, Stringifiable> = new Map([
    [views.Home, t.lazy('common.mainMenu.home')],
    [views.MyPerformance, t.lazy('common.mainMenu.myperf', { get canViewCampaigns() { return app.canViewCampaigns; } })],
    [views.Products, t.lazy('common.mainMenu.products')],
    [views.Forms, t.lazy('common.mainMenu.forms')],
    [views.Settings, t.lazy('common.userMenu.settings')],
    [views.Electronic, t.lazy('formAndLink.label.catergories.eService')],
    [views.Information, t.lazy('formAndLink.label.catergories.department')],
    [views.MyPerformance.CampaignListing, t.lazy('campaignListing.campaign.activity.title')],
    [views.EService.MyCustomer, t.lazy('myCustomer.title')],
]);

function getViewTitle(view: V) {
    return String(titles.get(view) || '');
}

function getFirstLevel(path: string = app.path): V | undefined {
    let params = app.route.parse(path);
    switch (params.section) {
        case null:
            return matchView(path, firstLevelViews);
        case 'settings':
            return views.Settings;
        case 'reminders':
            return views.Home;
        case 'departments':
            return views.Information;
        case 'e-service':
            return views.Electronic
    }
    return views.Forms;
}

function getParentViews(path: string = app.path): NavigationItem[] {
    let arr = [];
    let last;
    let p = path;
    while (p !== '/') {
        let matched = matchView(p);
        if (matched && matched !== last) {
            p = linkTo(matched);
            arr.unshift({
                label: getViewTitle(matched),
                href: p
            });
            last = matched;
        }
        p = p.replace(/\/[^/]+$/, '') || '/';
    }
    let firstLevel = getFirstLevel(path);
    if (firstLevel && firstLevel !== last) {
        arr.unshift({
            label: getViewTitle(firstLevel),
            href: linkTo(firstLevel)
        });
    }
    arr.pop();
    return arr;
}

const dropDownIcon: Map<string | undefined, IconNames> = new Map([
    ['homepage-change-password', 'lock']
]);

function getDropDownIcon(id: string) {
    return dropDownIcon.get(id);
}

export const navigationUtil = {
    getViewTitle,
    getFirstLevel,
    getParentViews,
    getDropDownIcon
};
